export default "__VITE_ASSET__VFJPci3R__"